import {gt06CommandStatus} from './gt06-command-result.js';

// Customer feedback describes the reply, never a measured reporting cadence.
export function gpsIntervalFeedback(reply, status, danish) {
  const accepted = gt06CommandStatus(reply, status) === 'command_accepted';
  const rejected = gt06CommandStatus(reply, status) === 'rejected';
  const messages = accepted
    ? ['Trackeren har accepteret ændringen.', 'The tracker has accepted the change.']
    : rejected
      ? ['Trackeren afviste ændringen.', 'The tracker rejected the change.']
      : ['Ændringen kunne ikke bekræftes. Trackeren har ikke bekræftet det nye interval.', 'The change could not be confirmed. The tracker has not confirmed the new interval.'];
  return {success: accepted, message: messages[danish ? 0 : 1]};
}

export function gpsIntervalError(code, danish, seconds = 60) {
  const messages = {
    interval_pair_required: ['Denne enhed kræver to intervalfelter. Åbn den opdaterede app, før du prøver igen.', 'This device requires two interval fields. Open the updated app before trying again.'],
    invalid_interval: ['Intervalværdierne understøttes ikke. Kontrollér begge felter.', 'The interval values are unsupported. Check both fields.'],
    rateLimited: ['Vent et øjeblik, før du prøver igen.', 'Please wait a moment before trying again.'],
    gt06_offline: ['Trackeren er offline. Prøv igen, når den har forbindelse.', 'The tracker is offline. Try again when it is connected.'],
    gt06_command_pending: ['Trackeren er ved at behandle en anden ændring. Vent et øjeblik.', 'The tracker is processing another change. Please wait a moment.'],
    devicePermission: ['Du har ikke adgang til at ændre intervallet.', 'You do not have permission to change the interval.'],
    feature_unavailable: ['Intervallet kan ikke ændres på denne enhed endnu.', 'The interval cannot be changed on this device yet.'],
    gt06_reply_timeout: ['Trackeren svarede ikke. Ændringen kunne ikke bekræftes.', 'The tracker did not reply. The change could not be confirmed.'],
    gt06_connection_closed: ['Forbindelsen blev afbrudt. Ændringen kunne ikke bekræftes.', 'The connection was lost. The change could not be confirmed.'],
    sessionRenewedRetry: ['Du er logget ind igen. Tryk på Gem opdateringsinterval for at prøve igen.', 'You are signed in again. Tap Save reporting interval to try again.'],
  }[code] ?? ['Ændringen kunne ikke bekræftes. Kontrollér forbindelsen, før du prøver igen.', 'The change could not be confirmed. Check the connection before trying again.'];
  return {success: false, message: messages[danish ? 0 : 1]};
}

export function gpsIntervalLabel(value, control, danish) {
  // Trial profiles deliberately retain unknown units and their restricted values.
  return control?.intervalUnit === 'seconds' ? `${value} ${danish ? 'sekunder' : 'seconds'}` : String(value);
}
